module.exports = __webpack_public_path__ + "img/my_bg_course@3x.6ec0b20d.png";